import React, { forwardRef } from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Slide, SlideProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Breakpoint } from "@mui/material";

const Transition = forwardRef(function Transition(props: SlideProps, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
interface DialogProps {
  dialogKey: string;
  title: string;
  content: React.ReactNode;
  dialogOpen: boolean;
  handleDialogClose: () => void;
  maxWidth: Breakpoint;
}

export const DialogComponent = ({
  dialogKey,
  title,
  content,
  dialogOpen,
  handleDialogClose,
  maxWidth = "sm",
}: DialogProps) => {
  const theme = useTheme();

  return (
    <Dialog
      open={dialogOpen}
      TransitionComponent={Transition}
      keepMounted
      maxWidth={maxWidth}
      fullWidth
      onClose={handleDialogClose}
      aria-describedby={dialogKey}
      sx={{
        "& .MuiPaper-root": {
          width: maxWidth,
          borderRadius: "10px",
        },
      }}
    >
      <DialogTitle
        align="center"
        color="primary"
        sx={{
          padding: "10px",
          fontSize: "22px !important",
          [theme.breakpoints.up("md")]: {
            padding: "24px 24px 10px",
          },
          fontWeight: "bold",
        }}
      >
        {title}
      </DialogTitle>
      {content}
    </Dialog>
  );
};
